import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const headline = tv({
	slots: {
		base: 'h-[45rem] lg:h-[61rem] relative mx-2 md:mx-4',
		inner: 'col-span-4 md:col-span-6 mx-2 lg:mx-4 flex justify-center relative',
	},
	variants: {
		theme: {
			light: {
				inner: 'border-black',
			},
			dark: {
				base: 'bg-black pb-4 md:pb-[14rem]',
				inner: 'border-white',
			},
			pink: {
				base: 'bg-mainPink pb-4 md:pb-[14rem]',
				inner: 'border-black',
			},
		},
		border: {
			true: {
				base: 'after:content-[""] after:block after:absolute after:w-full after:h-[1.5px] after:bg-black after:bottom-0 after:left-0',
			},
		},
	},
})

export type HeadlineVariants = VariantProps<typeof headline>
